export default {
  ACTIVE: {
    Title: 'Active',
    Color: '#FFE0CC',
  },
  IN_REVIEW: {
    Title: 'In review',
    Color: '#FDC200',
  },
  PROFILE_CREATED: {
    Title: 'Profile created',
    Color: '#FFD54F',
  },
  PROFILE_COMPLETE: {
    Title: 'Profile complete',
    Color: '#E9DFFF',
  },
  INTERVIEW_COMPLETE: {
    Title: 'Interview complete',
    Color: '#B3D9F2',
  },
  REJECTED: {
    Title: 'Rejected',
    Color: '#FFCDD2',
  },
  PAUSED: {
    Title: 'Paused',
    Color: '#D7CCC8',
  },
  INACTIVE: {
    Title: 'Inactive',
    Color: '#767676',
  },
};
